import {isError} from "lodash";

export function errorize(problem: unknown): Error {
    if (isError(problem)) {
        return problem;
    }
    return new Error("unknown error", {cause: problem});
}
